"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveJobRendererVariant = exports.RendererVariant = exports.RendererVersion = void 0;
var RendererVersion;
(function (RendererVersion) {
    RendererVersion["v6_0_0"] = "6.0.0";
    RendererVersion["v6_1_0"] = "6.1.0";
})(RendererVersion = exports.RendererVersion || (exports.RendererVersion = {}));
var RendererVariant;
(function (RendererVariant) {
    RendererVariant["Default"] = "default";
    RendererVariant["WorkerA"] = "workerA";
    RendererVariant["WorkerB"] = "workerB";
    RendererVariant["FastshotDefault"] = "fastshotDefault";
    RendererVariant["FastshotA"] = "fastshotA";
    RendererVariant["FastshotB"] = "fastshotB";
    RendererVariant["Test"] = "test";
})(RendererVariant = exports.RendererVariant || (exports.RendererVariant = {}));
function resolveJobRendererVariant(args) {
    if (args.runtime === "fastshot") {
        return RendererVariant.FastshotDefault;
    }
    return Math.random() < 0.05 ? RendererVariant.WorkerB : RendererVariant.WorkerA;
}
exports.resolveJobRendererVariant = resolveJobRendererVariant;
//# sourceMappingURL=JobRendererVersion.js.map